var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.6533C11.4477 13.6533 11 14.101 11 14.6533C11 15.2056 11.4477 15.6533 12 15.6533H17C17.5523 15.6533 18 15.2056 18 14.6533V9.65332C18 9.10104 17.5523 8.65332 17 8.65332C16.4477 8.65332 16 9.10104 16 9.65332V12.2391L11.7071 7.94621C11.3166 7.55569 10.6834 7.55569 10.2929 7.94621L8.00001 10.2391L3.70711 5.94621C3.31659 5.55569 2.68342 5.55569 2.29289 5.94621C1.90237 6.33674 1.90237 6.9699 2.29289 7.36043L7.2929 12.3604C7.68343 12.751 8.3166 12.751 8.70712 12.3604L11 10.0675L14.5858 13.6533H12Z",
    fill: "#F31260"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.9adfd8b0ff841cf6b92e43210be2c1a4.svg";
export { ForwardRef as ReactComponent };